const ctaButtonStyle = {
  px: 5,
  py: 1.6,
  borderRadius: 3,
  fontSize: "1rem",
  fontWeight: 600,
  textTransform: "none",
  color: "#fff",
  background: "linear-gradient(135deg, #ff9800, #ff5722)",
  boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
  transition: "all 0.25s ease-in-out",

  "&:hover": {
    background: "linear-gradient(135deg, #ffa726, #ff7043)",
    transform: "translateY(-2px) scale(1.04)",
    boxShadow: "0 10px 28px rgba(0,0,0,0.45)",
  },

  "&:active": {
    transform: "scale(0.98)",
  },
};

export default ctaButtonStyle;
